export default __webpack_public_path__ + "static/media/img21.b49afa90.jpg";